import { Link } from 'react-router-dom'
import { ArrowRight } from 'lucide-react'
import { site } from '../data/site.js'
import Badge from './Badge.jsx'

export default function ProductCard({ product }) {
  const Icon = product.icon
  const from = product.pricing?.find((t) => t.price != null)
  return (
    <div className="card flex flex-col p-6">
      <div className="flex items-start justify-between">
        <span className="grid h-12 w-12 place-items-center rounded-xl bg-accent/10 text-accent ring-1 ring-accent/20">
          <Icon className="h-6 w-6" />
        </span>
        <Badge status={product.status} />
      </div>
      <h3 className="mt-5 text-lg">{product.name}</h3>
      <p className="text-sm font-medium text-brand-300">{product.tagline}</p>
      <p className="mt-3 flex-1 text-sm text-slate-400">{product.summary}</p>
      {from && (
        <p className="mt-4 text-sm text-slate-400">
          From <span className="text-lg font-bold text-white">{site.currency}{from.price}</span>
          <span className="text-slate-500">/{from.period}</span>
        </p>
      )}
      <Link to={`/products/${product.slug}`} className="btn-primary mt-5">
        View plans <ArrowRight className="h-4 w-4" />
      </Link>
    </div>
  )
}
